import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Select from 'react-select'
import { BeatLoader } from 'react-spinners'
import PROPTYPES from '../../../lib/propTypes'

class PatientsView extends React.Component {
  static propTypes = {
    isFetchingSites: PropTypes.bool,
    sites: PROPTYPES.sites,
    getPatients: PropTypes.func,
    updatePatientBrand: PropTypes.func,
    patients: PropTypes.object,
    isFetchingPatients: PropTypes.bool
  }

  static defaultProps = {
    isFetchingSites: false,
    isFetchingPatients: false,
    getPatients: _.noop,
    updatePatientBrand: _.noop,
    patients: {}
  }

  constructor (ownProps) {
    super(ownProps)
    this.state = {
      selectedSite: null
    }
  }

  handleSelectSite = (site) => {
    const { getPatients } = this.props
    this.setState({
      selectedSite: site
    })
    if (site && site.id) {
      getPatients(site.id)
    }
  }

  updateBrandStatusForPatient = (brandStatus, patientId) => {
    const { updatePatientBrand } = this.props
    updatePatientBrand(patientId, {
      brand: brandStatus
    })
  }

  render () {
    const { isFetchingSites, sites, patients, isFetchingPatients } = this.props
    const { selectedSite } = this.state
    const sortedPatients = _.sortBy(patients, 'last_name')
    return (
      <div style={{ paddingTop: 20 }}>
        <Select
          isSearchable
          isClearable
          isLoading={isFetchingSites}
          options={sites}
          value={selectedSite}
          onChange={(selected) => this.handleSelectSite(selected)}
          onBlurResetsInput={false}
          onCloseResetsInput={false}
          noResultsText={false}
          labelKey={'name'}
          valueKey={'id'}
        />
        {
          isFetchingPatients ? (
            <div style={{ paddingTop: 40 }}>
              <BeatLoader loading color={'#6f8eaa'} />
            </div>
          ) : (
            <table style={{ marginTop: 20 }} className='table table-bordered'>
              <thead className='thead-light'>
                <tr>
                  <th scope='col'>First Name</th>
                  <th scope='col'>Last Name</th>
                  <th scope='col'>Brand</th>
                </tr>
              </thead>
              <tbody>
                {
                  _.map(sortedPatients, (patient) => ((
                    <tr key={`${patient.last_name}-${patient.id}`}>
                      <td>{patient.first_name}</td>
                      <td>{patient.last_name}</td>
                      <td><input className='form-check-input' type='checkbox' checked={patient.brand || false} onChange={(e) => this.updateBrandStatusForPatient(e.target.checked, patient.id)} /></td>
                    </tr>
                  )))
                }
              </tbody>
            </table>
          )
        }
      </div>
    )
  }
}

export default PatientsView



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/PatientsView.jsx